// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = "/auth";
const ROOTS_DASHBOARD = "/dashboard";
const ROOTS_HOSPITAL = "/hospital";
const ROOTS_MEDIC = "/medic";
const ROOTS_USERS = "/users";
const ROOTS_JOBMANAGEMENT = "/job-management";
const ROOTS_OUTSOURCE = "/outsourcing";
const ROOTS_SUBSCRIPTION = "/subscription";
const ROOTS_SUPPORT = "/support";
const ROOT_PROFILE = "/profile";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  signIn: path(ROOTS_AUTH, "/sign-in"),
  signUp: path(ROOTS_AUTH, "/sign-up"),
  resetPassword: path(ROOTS_AUTH, "/reset-password"),
  verification: path(ROOTS_AUTH, "/verification"),
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
};

export const PATH_HOSPITAL = {
  root: ROOTS_HOSPITAL,
  add: path(ROOTS_HOSPITAL, "/add"),
};

export const PATH_MEDIC = {
  root: ROOTS_MEDIC,
};

export const PATH_USER = {
  root: ROOTS_USERS,
  permissions: path(ROOTS_USERS, "/permissions"),
};
export const PATH_SUBSCRIPTION = {
  root: ROOTS_SUBSCRIPTION,
};

export const PATH_SUPPORT = {
  root: ROOTS_SUPPORT,
};
export const PATH_JOBMANAGEMENT = {
  root: ROOTS_JOBMANAGEMENT,
};
export const PATH_PROFILE = {
  root: ROOT_PROFILE,
};
export const PATH_OUTSOURCING = {
  root: ROOTS_OUTSOURCE,
};
